<section class="content">
  <div class="card" style="padding: 24px;">
  <div class="container-fluid">
    <div class="row">
      <div class="col" style="font-size: 23px;font-weight: 500; color: #278ecd; margin-bottom: 25px;">
        {{title}}
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <mat-label>From Date</mat-label>
        <input type="date" [(ngModel)]="from_date" class="main-border-class" />
      </div>
      <div class="col-3">
        <mat-label>To Date</mat-label>
        <input type="date" [(ngModel)]="to_date" class="main-border-class" />
      </div>
      <div class="col-2" style="padding-bottom: 2%;">
        <button (click)="getClicked()"
          style="font-size: 27px;margin-top: 14%;border-radius: 5px;background: blanchedalmond;">Get</button>
      </div>
    </div>
    <br>
    <div *ngIf="!is_document_available">
      <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="100">
      </mat-progress-spinner>
    </div>
    <div *ngIf="is_document_available">
      <div class="table-responsive" >
        <div class="row">
          <div class="col-6"></div>
          <div class="col-6">
            <div class="row">
              <div class="col-4">
                <mat-progress-spinner class="example-margin" [color]="color" [mode]="mode" [diameter]="50"
                  *ngIf="!is_document_available">
                </mat-progress-spinner>
              </div>
              <div class="col-4" *ngIf="document_details!== null">
                <button mat-button class="button-class" (click)="downloadReportCliked()"><i class="material-icons">
                    picture_as_pdf
                  </i> Download report</button>
              </div>
            </div>
          </div>
        </div>
        <br>

      </div>
    </div>
  </div>
  </div>
  <iframe [src]="pdf_data" width="100%" height="800" *ngIf="document_details!== null"></iframe>
</section>
